<template>
  <div
    class="position-fixed loading-background d-flex justify-content-center align-items-center">
    <LoadingSpinner class="loading-spinner-z-index" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import LoadingSpinner from '@/components/loading-spinner/LoadingSpinner.vue'

export default defineComponent({
  name: "LoadingSpinnerWithBackground",
  components: {
    LoadingSpinner
  }
})
</script>

<style lang="scss" scoped>
.loading-spinner-z-index {
  z-index: 1055
}

.loading-background {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
